import React, { useState, useEffect, useRef } from "react";
import { Grid, Button, Typography, Box } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import Snackbar from "../../../Components/Snackbar";
import { helpers } from "../../../helpers";

/** Local deoendencies & Libraries */
import Services from "../../../Services";

import NewFormFields from "../../../Components/InputComponents/NewFormFields";
import { gellAllLocomotiveLocations } from "../../../Services/LocomotiveServices";
import GoBack from "../../../Components/GoBackButton/GoBack";
import { message } from "antd";
import { ContractorTo, get_employee_listing_not_Terminated } from "../../../Services/employee";
import GoClose from "../../../Components/GoBackButton/Close";
import { seriliazeParams } from "../../../helpers/seriliazeParams";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";
const { employee, Storage } = Services;

const { showSnackBar } = helpers;

var moment = require("moment-timezone");
const Railroad = () => {
  let history = useHistory();
  const storage = new Storage();
  const [messageApi, contextHolder] = message.useMessage();

  //loader states
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [contractorList, setContractorList] = useState([]);
  const [flag, setFlag] = useState(true);
  const [assignedToType, setAssignedToType] = useState([null]);
  // const [assignedToType, setAssignedToType] = useState('');
  const [selectedAssignedToType, setSelectedAssignedToType] = useState([]);

  const [dataLists, setDataLists] = useState({
    eventType: []
  })
  const [railRoad, setRailRoad] = useState({
    crewMembers: [{ name: "", position: "", image: "" }],
  });

  /*document.getElementById( 'ojeComment').value = '')*/
  const resetData = () => {
    setRailRoad({
      stopTestFlag: false,
      stopTestComment: "",
      joinTestFlag: false,
      joinTestComment: "",
      assisting: {},
      assistingComment: "",
      department: "",
      site: "",
      eventType: "",
      GPS: "",
      date: new Date(),
      time: moment(new Date()).format("HH:mm:ss a"),
      jobId: "",
      crewMembers: [{ name: "", position: "", image: "" }],
    });
  };



  const apiBody = async () => {
    let GPS = railRoad.GPS;
    let [latitude, longitude] = GPS.split(",");
    let { crewMembers } = railRoad;
    let crewMembersData = [];
    crewMembers.forEach((row) => {

      if (row.name && row.position)
        crewMembersData.push({
          // id: row.name.id,
          id: row?.name?.id,
          position: row.position.id,
          image: row.image,
        });
      else throw Error("Images missing");
    });
    let data = {
      primaryId: lists?.currentUser?.id,
      assistingId: railRoad?.assisting?.id,
      DepartmentId: railRoad?.department?.id,
      site_id: railRoad?.site?.id,
      type: railRoad?.type?.id,
      latitude: latitude,
      longitude: longitude,
      date: moment(railRoad?.date).format("YYYY-MM-DD").toString(),
      time: railRoad?.time,

      jobId: railRoad?.jobId?.id,
      jobTitle: railRoad?.jobId?.title,
      // crewMember: crewMembersData,
      crewMember: crewMembersData,

      joinTestComment: railRoad?.joinTestComment?.length
        ? railRoad?.joinTestComment
        : "",


    };
    return data;
  };


  const [lists, setLists] = useState({
    currentUser: "",
    users: [],
    positions: [],
    departments: [],
    sites: [],
    crews: [],
    assistants: [],
    eventType: [],
    jobId: []

  });

  // for JOB ID
  const getSafetyTestEventList = async () => {
    let data = await employee.get_safety_testing_event_type(railRoad?.site?.id)

    setLists({
      ...lists,
      jobId: data?.data?.length ? data?.data?.map(value => { return { id: value?.id, title: value?.JobId } }) : []
    })
  }

  // for EVENT TYPE
  const getJobIDListing = async () => {
    let data = await employee.get_safety_testing_job_listing();
    if (data?.httpStatus === 200) {
      setDataLists({
        ...dataLists,
        eventType: data?.data.length ? data?.data.map(value => { return { id: value?.id, title: value?.Type } }) : ""
      })
    }
  }
  const contractormap = (data) => {
    let {
      firstName,
      lastName,
      Company
    } = data;

    let output = '';

    if (Company)
      output = Company;

    if (Company && firstName && lastName)
      output = output + "-"

    if (firstName && lastName)
      output = `${output} ${firstName} ${lastName[0]}.`

    return output;
  };
  const fetchAssignToList = async () => {
    let result = await get_employee_listing_not_Terminated()
    if (!result.ok) {
      throw new Error('Failed to fetch AssignTo listings');
    }
    const data = await result.json();
    return data;
  };

  const fetchContractorToList = async () => {
    let result = await ContractorTo();
    if (!result.ok) {
      throw new Error('Failed to fetch ContractorTo listings');
    }
    const data = await result.json();
    return data;
  };

  const fetchData = async () => {

    try {

      const employees = await employee.get_crew_user_listing();
      const contractors = await ContractorTo();

      setEmployeeList(employees?.data?.rows)
      setContractorList(contractors?.data)


    } catch (error) {
      console.error(`Error fetching ${assignedToType} listings:`, error.message);
      // Handle error (if needed)
    }
  };

  // Inside your component
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    getJobIDListing()
  }, [])


  useEffect(() => {
    if (railRoad?.site?.id) {
      getSafetyTestEventList()
    }

  }, [railRoad?.site])


  function onlySpaces(str) {
    return str.trim().length === 0;
  }

  const submitBtn = async (event) => {
    event.preventDefault();

    if (!loading) {
      setSuccess(false);
      setLoading(true);
      try {
        let data = await apiBody();

        if (!data.time || data.time.trim() === "") {
          setSuccess(false);
          setLoading(false);
          return showSnackBar("Please update the time.");
        }
        // Validate if images are uploaded for all crew members
        const imagesMissing = railRoad.crewMembers.some((member) => !member.image);

        if (imagesMissing) {
          setSuccess(false);
          setLoading(false);
          return showSnackBar("Please upload images for all crew members.");
        }
        let GPS = railRoad?.GPS;
        if (!GPS.includes(",")) {
          setSuccess(false);
          setLoading(false);
          return showSnackBar(
            "Longitude / Latitude should be seperated by a ',' "
          );
        }

        if (
          data.longitude == null ||
          data.longitude == undefined ||
          data.longitude == "" ||
          !data?.longitude?.length > 0 ||
          onlySpaces(data.longitude)
        ) {
          setSuccess(false);
          setLoading(false);
          return showSnackBar("Longitude / Latitude required");
        }

        if (
          data.latitude == null ||
          data.latitude == undefined ||
          data.latitude == "" ||
          onlySpaces(data.latitude)
        ) {
          setSuccess(false);
          setLoading(false);
          return showSnackBar("Longitude / Latitude required");
        }

        let result = await employee.create_test_event({ ...data });

        if (result?.httpStatus == 200) {


          setSuccess(true);
          setLoading(false);
          resetData();
          /*
          setTimout used to show , snackbar first and then route back to listing page
          */
          setTimeout(() => {
            history.push("/safety-testing");
          }, 1500);
          return showSnackBar("Form Successfully Submitted");
        }
      } catch (error) {
        setSuccess(false);
        setLoading(false);

        return showSnackBar(`Error Occured while submitting form: ${error}`);
      }
    }
    return false;
  };

  //add crew
  const addCrew = () => {
    let { crewMembers } = railRoad;
    crewMembers.push({ name: "", position: "", image: "" });
    setRailRoad({ ...railRoad, crewMembers });

  };

  //remove crew
  // const removeCrew = (index) => {
  //   const { crewMembers } = railRoad;
  //   crewMembers.splice(index, 1);
  //   setRailRoad({ ...railRoad, crewMembers });
  // };
  // const removeCrew = (index) => {
  //   const updatedCrewMembers = [...railRoad.crewMembers];
  //   updatedCrewMembers.splice(index, 1);
  //   setRailRoad({ ...railRoad, crewMembers: updatedCrewMembers });
  // };


  const removeCrew = (index) => {

    // railRoad?.crewMembers?.forEach((_, i) => document.getElementById(`crew${i}`).value = "");
    document.getElementById(`crew${index}`).value = ""

    const updatedCrewMembers = [...railRoad.crewMembers];
    const updatedAssignedToType = [...assignedToType];

    updatedCrewMembers.splice(index, 1);
    updatedAssignedToType.splice(index, 1);

    setRailRoad({ ...railRoad, crewMembers: updatedCrewMembers });
    setAssignedToType(updatedAssignedToType);
  };
  const showImageUploadSuccessMessage = () => {
    messageApi.success("Image uploaded successfully!");
  };
  const showImageUploadErrorMessage = () => {
    messageApi.error("Error uploading image. Please try again.");
  };
  // handle input change
  const handleInputChange = async (name, value, index) => {

    const { crewMembers } = railRoad;
    // if (name == "image") {
    //   value = await getBase64(value);
    //   showImageUploadSuccessMessage()
    //    
    // }
    if (name == "image") {
      if (!value) {
        // If image is not uploaded, show an alert message
        window.alert("Please upload an image for Crew Member " + (index + 1));
        return;
      }

      try {
        value = await getBase64(value);

        showImageUploadSuccessMessage();
      } catch (error) {
        console.error("Error uploading image:", error);
        showImageUploadErrorMessage();
        return; // Prevent further processing if there is an error
      }
    }
    crewMembers[index][name] = value;
    setRailRoad({ ...railRoad, crewMembers });
  };

  //convert image into base64

  const getBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const getLocation = async () => {
    function success(position) {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;

      let gps = `${latitude},${longitude}`;
      setRailRoad({ ...railRoad, GPS: gps });
    }

    function error(error) {

      setFlag(false);
      return showSnackBar(
        `Unable to retrieve your location: Kindly Enter Lat Long `
      );
    }

    if (!navigator.geolocation) {

    } else {

      navigator.geolocation.getCurrentPosition(success, error);
    }
  };


  const setListData = async () => {
    let userList = await employee.get_employee_listing();
    if (userList.httpStatus == 200) {
      userList = userList.data;
      userList.map((row) => {
        row.name = `${row.firstName} ${row.lastName}`;
      });

    }

    let assistingCrewList = await employee.get_crew_user_listing();
    let assistingMembers = await employee.get_assisting_member_listing();
    if (assistingCrewList.httpStatus == 200) {
      assistingCrewList = assistingCrewList.data.rows;
      assistingCrewList?.map((row) => {
        row.name = `${row.firstName} ${row?.middleName ? row?.middleName : ""} ${row.lastName}`;
      });

    }
    if (assistingMembers.httpStatus == 200) {
      assistingMembers = assistingMembers?.data?.rows;
      assistingMembers?.map((row) => {
        row.name = `${row.firstName} ${row.lastName}`;
      });

    }

    let params = '?'.concat(seriliazeParams({
      locationType: 'LOC,ALL,TST'
    }))
    let siteList = await gellAllLocomotiveLocations({ params });
    if (siteList.httpStatus == 200) {
      siteList = siteList.data;

    }
    let jobCategoryList = [
      { id: "ENG", title: "Engineer" },
      { id: "COND", title: "Conductor" },
      { id: "BR1", title: "BR1" },
      { id: "FMAN", title: "Trk-Foreman" },
      { id: "OPR", title: "Trk-Operator" },
      { id: "LABR", title: "Trk-Laborer" },
      { id: "TKINSP", title: "Trk-Inspector" },
      { id: "SUPV", title: "Trk-Supervisor" },
      { id: "MGR", title: "Trk-Manager" },
      { id: "OTHER", title: "OTHER" },
    ];

    let departmentList = [
      { id: "Transportation", title: "Transportation" },
      { id: "Engineering", title: "Engineering" },
      { id: "Mechanical", title: "Mechanical" },
    ];

    let currentUser = JSON.parse(storage.get("user_profile"));
    setLists({
      ...lists,
      users: userList,
      crews: assistingCrewList,
      assistants: assistingMembers,
      positions: jobCategoryList,
      departments: departmentList,
      sites: siteList,
      currentUser: currentUser,
    });
    return true;
  };

  useEffect(async () => {
    await setListData();
  }, []);

  const handleOnChange = (value, key) => {
    if (key === "date") {
      // Check if the selected date is in the future
      const selectedDate = new Date(value);
      const currentDate = new Date();
      if (selectedDate > currentDate) {
        // Show an error message or perform other actions as needed
        messageApi.info('You can not select the future dates');
        return;
      }
    }


    setRailRoad({ ...railRoad, [key]: value });
  };

  let currentUser = JSON.parse(storage.get("user_profile"));

  let fields = [
    {
      type: 1,
      grid: 5,
      name: "Primary",
      initial: `${currentUser?.firstName} ${currentUser?.lastName}`,
      isDisabled: true,
    },
    { type: 3, grid: 5, key: 'title', name: "Event Type", keyName: "type", options: dataLists?.eventType.length ? dataLists?.eventType : "", isRequired: true },
    {
      type: 3,
      grid: 5,
      key: "title",
      options: lists.departments,
      name: "Department",
      isRequired: true,
      keyName: "department",
      className: "mbold relative LocIcon ",
    },
    {
      type: 10,
      nameplaceholder: "Comment",
      isRequired: false,
      grid: 5,
      name: "Event Description",
      keyName: "joinTestComment",
      minRows: 8
    },
    {
      type: 3,
      grid: 5,
      key: "name",
      options: lists.assistants,
      name: "Assisting",
      isRequired: false,
      keyName: "assisting",
      customStyle: {
        margin: {
          top: "-140px"
        }
      }
    },
    { type: 8, grid: 12, name: "Location & Date/Time", className: "layout" },
    {
      type: 3,
      grid: 5,
      key: "title",
      options: lists.sites,
      name: "Site",
      isRequired: true,
      keyName: "site",
      className: "mbold relative TargetIcon",
    },
    {
      type: 5,
      grid: 5,
      key: "title",
      name: "Time",
      isRequired: true,
      keyName: "time",
      className: "mbold relative TimeIcon",
    },
    {
      type: 11,
      grid: 5,
      key: "title",
      initial: railRoad.date,
      name: "Date",
      isRequired: true,
      keyName: "date",
      className: "mbold relative DateIcon",
    },
    {
      type: 1,
      grid: 4,
      key: "title",
      initial: railRoad?.GPS,
      currentVal: true,
      name: "GPS",
      isRequired: true,
      keyName: "GPS",
      className: "mbold relative TargetIcon gps-layout",
    },
    {
      type: 9,
      grid: 1,
      buttonText: "GET",
      className: "GetBtn mt-20 ",
      onClick: getLocation,
    },
    { type: 8, grid: 12, name: "Crew", className: "layout" },
    {
      type: 3,
      grid: 5,
      key: "title",
      options: lists?.jobId,
      name: "Job ID",
      isRequired: true,
      keyName: "jobId",
      className: "",
      initial: null,
    },
  ];




  return (
    <PageLayout >
      {contextHolder}
      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">Railroad Testing Event</Grid>
        {/* Page Start */}
        <GoBack path={"/safety-testing"} />

        <Grid xs={12} className="ContentPage FormTableArea">
          <form style={{ width: "100%" }} onSubmit={submitBtn} >
            <Grid xs={12} container>
              <Typography
                variant="h5"
                className="mbold f16 layout-2"
                component="h6"
              >
                Evaluators
              </Typography>
            </Grid>

            <Box
              sx={{
                display: "grid",
                gap: "30px",
                // gridTemplateColumns: 'repeat(3,1fr)',
              }}
              className="flexing"
            >
              <NewFormFields
                onChange={handleOnChange}
                fields={fields}
                grid={true}
              />
              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
                xs={12}
                md={4}
                container
                className="fieldSubText"
              >
                <Button
                  style={{ maxHeight: "50px" }}
                  className="LinkButton ButtonAddIcon"
                  onClick={addCrew}
                >
                  Add Crew Member
                </Button>
              </Grid>
            </Box>

            <Grid>

            </Grid>


            <Grid>
              <Grid xs={12} className="Scrolling SafetyCrewHeight mt30">
                {railRoad?.crewMembers.map((x, i) => (
                  <Grid xs={12} container className="mt30" key={i}>
                    {!assignedToType[i] && (
                      <Grid xs={5} className="pr20">
                        <Grid xs={12} className="mbold">
                          {`Crew Member ${i + 1}`}
                        </Grid>
                        <Grid item xs={12}>

                          <Autocomplete
                            className="w100p"
                            id={`combo-box-name-${i}`}
                            name="assignedTo"
                            options={['Contractor', 'Employee']}
                            value={assignedToType[i] ? assignedToType[i] : null}
                            // defaultValue={assignedToType[i] ? assignedToType[i] : null}
                            onChange={(e, value) => {
                              let tempTypes = [...assignedToType]
                              tempTypes[i] = value
                              let tempRailroad = { ...railRoad };

                              // if (value == 'Employee')
                              //   tempRailroad.crewMembers[i].employee = employeeList[0]
                              // else
                              //   tempRailroad.crewMembers[i].contractor = contractorList[0]
                              setAssignedToType(tempTypes)

                              setRailRoad({ ...tempRailroad })
                            }}
                            getOptionLabel={(option) => option}
                            renderInput={(params) => (
                              <TextField
                                required={true}
                                {...params}
                                label="Select"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    )}
                    {
                      assignedToType[i] && (
                        <Grid xs={5} className="pr20">
                          <Grid xs={12} className="mbold">
                            {`Crew Member ${i + 1}`}
                          </Grid>
                          <Grid item xs={12}>
                            {assignedToType[i] === 'Employee' ? (
                              <Autocomplete
                                className="w100p"
                                id={`combo-box-employee-${i}`}
                                name="AssignedToId"
                                options={['Back', ...employeeList] || []} // Add 'Back' option to the options array
                                value={railRoad?.crewMembers[i]?.name || null}
                                onChange={(e, value) => {

                                  if (value == 'Back') {
                                    let temp = [...assignedToType]
                                    temp[i] = false
                                    handleInputChange('name', null, i)
                                    return setAssignedToType(temp)
                                  }
                                  else {
                                    // let tempRailroad = { ...railRoad };
                                    // tempRailroad.crewMembers[i].employee = value
                                    handleInputChange('name', value, i)
                                  }
                                }}
                                getOptionLabel={(option) => {
                                  if (option === 'Back') {
                                    return option
                                    // } else if (option === 'Employee') {
                                    //   return employeeList[0]?.firstName + ' ' + employeeList[0]?.lastName;
                                  } else {
                                    return option?.firstName + ' ' + option?.lastName;
                                  }
                                }}
                                renderOption={(props, option) => {

                                  if (props == "Back")
                                    return <strong style={{ margin: 'auto' }}>Back</strong>
                                  return props?.firstName + ' ' + props?.lastName
                                }}
                                renderInput={(params) => {


                                  return <TextField
                                    required={true}
                                    {...params}
                                    label="Select Employee"
                                    variant="outlined"
                                  />
                                }}
                              />
                            )
                              : (
                                <Autocomplete
                                  className="w100p"
                                  id={`combo-box-contractor-${i}`}
                                  onChange={(e, value) => {
                                    if (value == 'Back') {
                                      let temp = [...assignedToType]
                                      temp[i] = false
                                      handleInputChange('name', null, i)
                                      setAssignedToType(temp)
                                    }
                                    else {
                                      // let tempRailroad = { ...railRoad };
                                      // tempRailroad.crewMembers[i].contractor = value
                                      handleInputChange('name', value, i)
                                    }
                                  }}
                                  options={['Back', ...contractorList] || []} // Add 'Back' option to the options array

                                  value={railRoad?.crewMembers[i]?.name || null}
                                  getOptionLabel={(option) => {
                                    if (option === 'Back') {
                                      return option;
                                    }
                                    else if (option == 'Contractor')
                                      return contractormap(contractorList[0]);
                                    else
                                      return contractormap(option);
                                  }}
                                  renderOption={(props, option) => {

                                    if (props == "Back")
                                      return <strong style={{ margin: 'auto' }}>Back</strong>
                                    return contractormap(props)
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      required={true}
                                      {...params}
                                      label="Select Contractor"
                                      variant="outlined"
                                    />
                                  )}
                                />
                              )}
                          </Grid>
                        </Grid>
                      )}




                    {/* Crew Position Section */}
                    <Grid xs={7} container>
                      <Grid xs={12} className="mbold">
                        Crew Position
                      </Grid>
                      <Grid xs={7}>
                        <Autocomplete
                          className="w100p"
                          id={`combo-box-demo-${i}`}
                          name="position"
                          options={lists.positions}
                          getOptionLabel={(option) => option.title}
                          value={x.position}
                          onChange={(e, value) => {
                            handleInputChange("position", value, i);
                          }}
                          renderInput={(params) => (
                            <TextField
                              required={true}
                              {...params}
                              label="Select"
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>
                      <Grid xs={5} container justify="space-evenly" className="pl20">
                        <label
                          className={
                            x.image === "" ? "PickBtn required" : "PickBtnFileUploaded"
                          }
                          htmlFor={`crew${i}`}
                        >
                          {x.image === "" ? "*" : null}
                        </label>
                        <input
                          required
                          type="file"
                          id={`crew${i}`}
                          name="image"
                          className="hide"
                          onChange={(e) => {
                            let value1 = e.target.files[0];
                            handleInputChange("image", value1, i);
                          }}
                        />
                        {railRoad.crewMembers.length !== 1 && (
                          <button
                            type="button"
                            className="removeBtn"
                            onClick={() => removeCrew(i)}
                          ></button>
                        )}
                      </Grid>

                      {/* 
                        <Grid xs={5} container justify="space-evenly" className="pl20">
                          <label
                            className={
                              x.image == "" ? "PickBtn" : "PickBtnFileUploaded"
                            }
                            style={{ color: "red" }}
                            htmlFor={`crew${i}`}
                          >
                            *
                          </label>
                          <input
                            required
                            type="file"
                            id={`crew${i}`}
                            name="image"
                            className="hide"
                            onChange={(e) => {
                              let value1 = e.target.files[0];
                              handleInputChange("image", value1, i);
                            }}
                          />
                          {railRoad.crewMembers.length !== 1 && (
                            <button
                              type="button"
                              className="removeBtn"
                              onClick={() => removeCrew(i)}
                            ></button>
                          )}
                        </Grid> */}
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>




            <Grid xs={12} container justify="flex-end" className="mt50">
              {/* <Link to="/safety-testing" className="LinkButtonBack mr10">
                  Close
                </Link> */}
              <GoClose path={"/safety-testing"} />

              <Button
                type="submit"
                className="LinkButton"
              // onClick={submitBtn}
              >
                Save
              </Button>
            </Grid>
          </form>
          <Snackbar></Snackbar>
        </Grid>
        {/* Page Start End */}
      </Grid>
    </PageLayout>
  );
};

export default Railroad;
